export default {
    error(msg, example) {
        console.group('trio-assets-js - error');
        console.error(msg);
        console.log(`%cAvailable options`, 'color: green', example);
        console.groupEnd();
    },
}
